import React from 'react';

import { routes } from '@/assets/constants/routes-no.ts';
import { ArrowLink } from '@/competitions/_common/components/ArrowLink.tsx';
import { UnderlinedText } from '@/components/UnderlinedText/index.ts';
import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';

import BlueEgg from '../_assets/blue-egg.svg?react';
import SignSmall from '../_assets/sign-small.svg?react';
import Sign from '../_assets/sign.svg?react';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';

export type BottomSectionProps = {
  activeCompetition: CompetitionWithConfig | undefined;
};

export const BottomSection: React.FC<BottomSectionProps> = (props) => {
  return (
    <Section sx={{ maxWidth: '1560px' }}>
      <div className="grid w-full gap-4 md:grid-cols-2 xl:grid-cols-[auto_1fr_1fr]">
        <Sign className="mx-auto hidden xl:mr-40 xl:block" />
        <SignSmall className="mx-auto md:col-span-2 xl:hidden" />
        <div className="mx-auto flex h-full max-w-sm flex-1 flex-col rounded-lg bg-[#FFF4E0] p-6 md:max-w-md lg:max-w-full">
          <div className="mb-4 typography-v1-h2">
            Bruk regel{' '}
            <span className="inline-grid aspect-square size-[1.4em] place-items-center rounded-full bg-v1-neutral-100 text-[0.8em] leading-none text-white">
              3
            </span>
          </div>
          <p className="mb-8 typography-v1-body2">
            Sjekk om du kan få lavere rente og delta om å vinne inntil 500.000 til nedbetaling av
            gjeld
          </p>

          <CTA
            activeCompetition={props.activeCompetition}
            sx={{ mt: 'auto', ml: '0' }}
            onClick={() => {
              sendUserPortalEvent('mar25_competition_cta_bottom_clicked');
            }}
          />
          <ArrowLink to={routes.MARCH_2025_COMPETITION_TERMS} sx={{ display: 'block', mt: 3 }}>
            Vilkår og betingelser
          </ArrowLink>
        </div>

        <div className="mx-auto flex h-full max-w-sm flex-1 flex-col rounded-lg bg-[#EFF7FF] p-6 md:max-w-md lg:max-w-full">
          <div className="mb-8 typography-v1-h2">
            Vi ønsker at enda flere skal få <UnderlinedText>bedre gjeldvett!</UnderlinedText>
          </div>
          <p className="mb-4 typography-v1-body2">
            Det finnes flere gode grep for å bli raskere gjeldfri. Gjennom våre gjeldvettregler har
            vi samlet de vi mener er de viktigste og enkleste grepene du kan gjøre for å få bedre
            kontroll over din usikrede gjeld.
          </p>
          <BlueEgg className="mt-auto ml-auto" />
        </div>
      </div>
    </Section>
  );
};
